'use strict';
import { assign } from 'lodash';
import moment from 'moment-timezone';
angular.module('docketbook').
  controller('jobDetailController', function (orderService, docketService, jobService, xeroService, userService, $q, $rootScope, $scope, $state, $stateParams, $mdpDatePicker, $mdpTimePicker, $mdToast, $mdBottomSheet, splitListInterface, $http, Restangular, accessControl, uuid, $timeout, scroll, geolocation) {

    // Main Variables For Doing Stuff
    $scope.moment = moment;
    $scope.itemEdit = null;

    $scope.docketsQuery = {
      limit: 10,
      page: 1,
      order: 'docketNumber'
    };
    $scope.docketsPromise = null;

    // Base Access Data
    $scope.currentUser = accessControl.currentUser();
    $scope.currentOrgGroup = accessControl.currentOrgGroup();
    $scope.currentOrg = accessControl.currentOrg();
    $scope.splitListFunc = new splitListInterface($scope, $stateParams);
    $scope.userCanDoAction = userService.userCanDoAction;
    $scope.subcontractorCounts = [];
    $scope.resolutionMap = {
      loading: false,
      map: {}
    }
    $scope.cleanAssignees = [];
    $scope.resolveToRealEntities = function () {
      //we want to extract the subcontractors and assignees
      //for each 'forwarder' on the ACL resolve their email address
      //for each 'assignee' resolve the context they were assigned in
      const params = {
        organisations: [],
        organisationGroups: [],
        principals: [],
      }
      if (($scope.itemEdit) && ($scope.itemEdit.accessControl)) {
        Object.keys($scope.itemEdit.accessControl).forEach((key) => {
          const roles = $scope.itemEdit.accessControl[key];
          if ((params.principals.indexOf(key) === -1)) {
            params.principals.push(key)
          }
        })
      }
      if (($scope.itemEdit) && ($scope.itemEdit.assignees)) {
        $scope.itemEdit.assignees.forEach((assignee) => {
          if ((assignee.organisation) && (params.organisations.indexOf(assignee.organisation) === -1)) {
            params.organisations.push(assignee.organisation);
          }
          if ((assignee.organisationGroup) && (params.organisationGroups.indexOf(assignee.organisationGroup) === -1)) {
            params.organisationGroups.push(assignee.organisationGroup);
          }
        })
      }
      let anythingToLookup = false;
      const queryItems = {};
      if (params.organisations.length > 0) {
        queryItems.organisations = params.organisations.join(',');
        anythingToLookup = true;
      }
      if (params.organisationGroups.length > 0) {
        queryItems.organisationGroups = params.organisationGroups.join(',');
        anythingToLookup = true;
      }
      if (params.principals.length > 0) {
        queryItems.principals = params.principals.join(',');
        anythingToLookup = true;
      }
      if (!anythingToLookup) {
        return;
      }
      $scope.resolutionMap.loading = true;
      Restangular.all('lookup').customGET("", queryItems).then((response) => {
        $scope.resolutionMap.loading = false;
        const newMap = {};
        ['organisations', 'organisationGroups', 'users'].forEach((key) => {
          if (response[key] === undefined) {
            return;
          }
          response[key].forEach((record) => {
            record.type = key;
            newMap[record.id] = record;
            if (record.originalPrincipal) {
              newMap[record.originalPrincipal] = record;
            }
          })
        })
        $scope.resolutionMap.map = newMap;
        $scope.updateSubcontractorMappings();
      })
    }

    $scope.updateSubcontractorMappings = function () {
      //to get a full list of subcontractors on this job, its the union between
      //the list of forwarders (from ACL) and the list of org groups from the
      //actual assignees list
      let subcontractors = [];
      if (($scope.itemEdit) && ($scope.itemEdit.forwarders)) {
        $scope.itemEdit.forwarders.forEach((forwarder) => {
          const newSubcontractor = {
            principal: forwarder,
            name: forwarder,
          }
          if ($scope.resolutionMap.map[forwarder] !== undefined) {
            newSubcontractor.entity = $scope.resolutionMap.map[forwarder];
            newSubcontractor.name = newSubcontractor.entity.name;
            newSubcontractor.id = newSubcontractor.entity.id;
          }
          subcontractors.push(newSubcontractor);
        })
      }
      /*
      if (($scope.itemEdit) && ($scope.itemEdit.assignees)) {
        $scope.itemEdit.assignees.forEach((assignee) => {
          //check to see if the subcontractor already exists
          const subMatch = subcontractors.find((sub) => {
            return sub.id && sub.id === assignee.organisationGroup;
          });
          if (subMatch) {
            return;
          }
          const newSubcontractor = {
            id: assignee.organisationGroup,
            name: assignee.organisationGroup,
          }
          if ($scope.resolutionMap.map[assignee.organisationGroup] !== undefined) {
            newSubcontractor.entity = $scope.resolutionMap.map[assignee.organisationGroup];
            newSubcontractor.name = newSubcontractor.entity.name;
            newSubcontractor.id = newSubcontractor.entity.id;
          }
          subcontractors.push(newSubcontractor);
        })
      }*/
      let subContractorCounts = subcontractors.map((sub) => {
        const countObj = Object.assign({
          assigned: 0,
          accepted: 0,
          rejected: 0
        }, sub);
        if (($scope.itemEdit) && ($scope.itemEdit.assignees)) {
          $scope.itemEdit.assignees.forEach((assignee) => {
            if (sub.id === assignee.organisationGroup) {
              if (assignee.status.toLowerCase() === 'assigned') {
                countObj.assigned += 1;
              } else if (assignee.status.toLowerCase() === 'accepted') {
                countObj.accepted += 1;
              } else if (assignee.status.toLowerCase() === 'rejected') {
                countObj.rejected += 1;
              }
            }
          })
        }
        return countObj
      })
      $scope.subcontractorCounts = subContractorCounts;
      if ($scope.itemEdit.organisation === $scope.currentOrg.id) {
        $scope.cleanAssignees = $scope.itemEdit.assignees
      } else {
        $scope.cleanAssignees = $scope.itemEdit.assignees.filter((assignee) => {
          if (('organisation' in assignee) && ('organisationGroup' in assignee)) {
            return assignee.organisation === $scope.currentOrg.id && assignee.organisationGroup === $scope.currentOrgGroup.id;
          }
          return true;
        })
      }
    }


    /***************************************/
    /***** Parent Controlled Functions *****/
    /***************************************/

    $scope.$parent.currentActiveTab = function () {
      return $scope.currentTab;
    }

    $scope.$parent.getJobFromParent = function () {
      return $scope.itemEdit;
    }

    $scope.$parent.prepareForJobFromParent = function (openTab, jobNumber, job) {
      $scope.itemEdit = {};
      if (jobNumber != null) {
        $scope.itemEdit.jobNumber = jobNumber;
      }
      if (job) {
        $scope.itemEdit.jobId = job;
      }
      $scope.itemEdit.loading = true;
      $scope.itemEdit.loadingType = "getting";
      $scope.newComment = { 'commentText': '' };
      if (openTab) {
        $scope.currentTab = openTab;
      } else {
        $scope.currentTab = "General";
      }
      if ($stateParams.device == 'mobile') {
        $timeout(function () {
          $scope.openMobileTab($scope.currentTab);
        }, 500);
      }
    }

    $scope.refreshForwardersFromAccessControl = function () {
      //we want to extract any forwarders in the ACL and populate the subcontractors list
      const forwarders = Object.keys($scope.itemEdit.accessControl).filter((entry) => {
        let existingForwarder = false;
        if (Array.isArray($scope.itemEdit.accessControl[entry])) {
          existingForwarder = $scope.itemEdit.accessControl[entry].indexOf('forwarder') !== -1
        } else {
          if ('add' in $scope.itemEdit.accessControl[entry] && $scope.itemEdit.accessControl[entry].add.indexOf('forwarder') !== -1) {
            existingForwarder = true;
          }
        }

        let newForwarder = false;
        return existingForwarder || newForwarder;
      });
      $scope.itemEdit.forwarders = forwarders;
      $scope.resolveToRealEntities();
    }

    $scope.$parent.loadJobFromParent = function (job, edit) {
      $scope.itemEdit = job;
      $scope.itemEdit.loading = true;
      $scope.itemEdit.loadingType = 'getting';
      $scope.itemEdit.loading = false;

      if ($scope.itemEdit.order && $scope.itemEdit.order.supplierRefNo) {
        var refNoSplit = $scope.itemEdit.order.supplierRefNo.split('_');
        if (refNoSplit.length > 0 && refNoSplit[0] == 'xq') {
          $scope.itemEdit.xeroQuote = true;
          $scope.itemEdit.xeroQuoteId = refNoSplit[2];

          xeroService.getXeroQuote($scope.itemEdit.xeroQuoteId, function (quote) {
            $scope.itemEdit.xeroQuoteFull = quote;
          })
        }
      }

      $scope.refreshForwardersFromAccessControl();
      if ($stateParams.device == 'desktop') {
        if (edit && edit == true) {
          $scope.itemEdit.editing = true;
        } else {
          $scope.itemEdit.editing = false;
        }
      } else {
        if ($scope.userCanDoAction('canEditJob', $scope.itemEdit)) {
          $scope.itemEdit.editing = true;
        } else {
          $scope.itemEdit.editing = false;
        }
      }
      $scope.loadJobDockets($scope.itemEdit);
      $scope.resolveToRealEntities();
    }

    $scope.$parent.newJobFromParent = function (fromId) {
      $scope.newJob(fromId);
    }

    $scope.$parent.clearJobFromParent = function () {
      $scope.itemEdit = null;
    }

    $scope.loadJobDockets = function (job) {
      $scope.docketsPromise = $q(function (resolve, reject) {
        if (job.id == null) {
          job.dockets = [];
          resolve('Done');
          return;
        }

        var params = [];
        params['limit'] = $scope.docketsQuery.limit;
        params['offset'] = $scope.docketsQuery.limit * ($scope.docketsQuery.page - 1);
        params['sort'] = $scope.docketsQuery.order;
        params['jobRef'] = job.id;

        docketService.getDockets(params, function (returnData) {
          var docketsListParsed = docketService.parseDockets(returnData);
          job.dockets = docketsListParsed;
          resolve('Done');
        }, function (err) {
          reject('Error');
        });
      });
    }

    $scope.$parent.loadJobDocketsNextPage = function (cb) {
      var offsetPre = $scope.docketsQuery.limit * ($scope.docketsQuery.page - 1);
      $scope.docketsQuery.page = $scope.docketsQuery.page + 1;
      var offset = $scope.docketsQuery.limit * ($scope.docketsQuery.page - 1);
      // get next page of dockets from docketService using pagination query params
      var params = [];
      params['limit'] = $scope.docketsQuery.limit;
      params['offset'] = $scope.docketsQuery.limit * ($scope.docketsQuery.page - 1);
      params['sort'] = $scope.docketsQuery.order;
      params['jobRef'] = $scope.itemEdit.id;

      docketService.getDockets(params, function (returnData) {
        var docketsListParsed = docketService.parseDockets(returnData);
        for (var i = 0; i < docketsListParsed.length; i++) {
          $scope.itemEdit.dockets.push(docketsListParsed[i]);
        }
        cb();
      });
    }

    /**********************************/
    /***** Main Job Functionality *****/
    /**********************************/

    // Create a new job - setup job data
    $scope.newJob = function (fromId) {
      var newJob = {
        'status': 'New', 'statusDisplay': 'New', 'jobNumber': 'New Job', 'startDate': new Date(), 'endDate': new Date(), 'lineItems': [], 'userIsAssignee': false,
        organisation: $scope.currentOrg.id, organisationGroup: $scope.currentOrgGroup.id,
        // accessControl: {
        // 	 [$scope.currentOrgGroup.emailAddress]: ['editor']
        // }
      };

      // if creating from order - pre-populate order ref and line items
      if (fromId != null) {
        orderService.getOrder(fromId, function (fullOrder) {
          newJob.orderRef = fullOrder;
          // populate line items
          newJob.lineItems = [];
          var lineItems = angular.copy(fullOrder.lineItems);
          for (var i = 0; i < lineItems.length; i++) {
            var newLineItem = lineItems[i];
            newLineItem.quantity = "";
            if (newLineItem.id) {
              newLineItem.orderItemId = newLineItem.id;
            }
            delete newLineItem.id;
            if (newLineItem.resource != null) {
              newJob.lineItems.push(newLineItem);
            }
          }
          // copy supplier and customer contact from order
          if (fullOrder.customerContact != null) {
            newJob.customerContact = angular.copy(fullOrder.customerContact);
          }
          if (fullOrder.supplierContact != null) {
            newJob.supplierContact = angular.copy(fullOrder.supplierContact);
          }
          // finish
          $scope.itemEdit = newJob;
          $scope.itemEdit.editing = true;
          $scope.currentTab = "General";
        }, function (err) {
          // finish
          $scope.itemEdit = newJob;
          $scope.itemEdit.editing = true;
          $scope.currentTab = "General";
        });
      } else {
        $scope.itemEdit = newJob;
        $scope.itemEdit.editing = true;
        $scope.currentTab = "General";
      }
    }

    /***********************************/
    /***** Other Job Functionality *****/
    /***********************************/

    $scope.$parent.resetNewComment = function () {
      $scope.newComment = { 'commentText': '' };
    }

    /************************/
    /***** Assign Order *****/
    /************************/

    $scope.selectOrder = function () {
      if ($scope.currentOrgGroup) {
        var supplierEmails = $scope.currentOrgGroup.emailAddresses;
      }
      var options = { currentOrder: $scope.itemEdit.orderRef, statusList: 'draft,sent,accepted', supplier: supplierEmails, hasCustomer: true, hasOrderNumber: true };
      $scope.$parent.selectOrderForJob(options, function (order) {
        if (order != null) {
          orderService.getOrder(order.id, function (fullOrder) {
            $scope.itemEdit.orderRef = fullOrder;
            if (fullOrder.customerContact) {
              $scope.itemEdit.customerContact = fullOrder.customerContact;
            }
            if (fullOrder.supplierContact) {
              $scope.itemEdit.supplierContact = fullOrder.supplierContact;
            }
          }, function (err) {
            console.error('an error occured getting the full order ref for the job', err);
          });
        }
      });
    }

    /**************************/
    /***** Add Line Items *****/
    /**************************/

    $scope.selectLineItem = function () {
      var lineList = $scope.itemEdit.orderRef.lineItems;
      // disabled existing line items
      for (var i = 0; i < lineList.length; i++) {
        lineList[i].disabled = false;
        for (var j = 0; j < $scope.itemEdit.lineItems.length; j++) {
          if (lineList[i].id == $scope.itemEdit.lineItems[j].orderItemId && $scope.itemEdit.lineItems[j].delete != true) {
            lineList[i].disabled = true;
            break;
          }
        }
      }

      $scope.$parent.selectLineFromOrder(lineList, function (lineItem, from) {
        if (lineItem != null) {
          if (from && from == 'desktop') {
            for (var i = 0; i < lineItem.length; i++) {
              var lineItemToPush = angular.copy(lineItem[i]);
              lineItemToPush.orderItemId = lineItem[i].id;
              delete lineItemToPush.id;
              $scope.itemEdit.lineItems.push(lineItemToPush);
            }
          } else {
            var lineItemToPush = angular.copy(lineItem);
            lineItemToPush.orderItemId = lineItem.id;
            delete lineItemToPush.id;
            $scope.itemEdit.lineItems.push(lineItemToPush);
          }
        }
      });
    }

    $scope.removeLineItem = function (lineItem) {
      lineItem.delete = true;
    }

    $scope.editLineItem = function (lineItem) {
      var lineItemEdit = lineItem;
      lineItemEdit.resourceLocked = true;
      lineItemEdit.jobView = true;

      // if time resource - format quantity as per abbreviation
      if (lineItemEdit.resource.uom.isTime) {
        var quantity = lineItemEdit.quantity;
        var abbreviation = lineItemEdit.resource.uom.abbreviation;
        if (abbreviation == 'h' || abbreviation == 'H' || abbreviation == 'hours' || abbreviation == 'hrs') {
          // display as hours
          lineItemEdit.quantityEdit = quantity / 60;
          lineItemEdit.quantityEditType = 'h';
        }
        if (abbreviation == 'hm' || abbreviation == 'HM' || abbreviation == 'hoursminutes' || abbreviation == 'hrsmins') {
          // display as hours and minutes
          var hours = Math.floor(quantity / 60);
          var minutes = quantity % 60;
          lineItemEdit.quantityHoursEdit = hours;
          lineItemEdit.quantityMinutesEdit = minutes;
          lineItemEdit.quantityEditType = 'hm';
        }
        if (abbreviation == 'm' || abbreviation == 'M' || abbreviation == 'minutes' || abbreviation == 'mins') {
          lineItemEdit.quantityEdit = quantity;
          lineItemEdit.quantityEditType = 'm';
        }
      } else {
        lineItemEdit.quantityEdit = lineItemEdit.quantity;
        lineItemEdit.quantityEditType = 'normal';
      }

      $scope.$parent.editLineItemForJob($scope.itemEdit, lineItemEdit, function (item) {
        if (item != null) {
          // if time resource - format quantity from abbreviation to minutes
          if (item.resource.uom.isTime) {
            var abbreviation = item.resource.uom.abbreviation;
            if (abbreviation == 'h' || abbreviation == 'H' || abbreviation == 'hours' || abbreviation == 'hrs') {
              // convert from hours to minutes
              item.quantity = item.quantityEdit * 60;
            }
            if (abbreviation == 'hm' || abbreviation == 'HM' || abbreviation == 'hoursminutes' || abbreviation == 'hrsmins') {
              // display from hours&minutes to minutes
              var totalMinutes = 0;
              totalMinutes += parseInt(item.quantityHoursEdit) * 60;
              totalMinutes += parseInt(item.quantityMinutesEdit);
              item.quantity = totalMinutes;
            }
            if (abbreviation == 'm' || abbreviation == 'M' || abbreviation == 'minutes' || abbreviation == 'mins') {
              item.quantity = item.quantityEdit;
            }
          } else {
            item.quantity = item.quantityEdit;
          }

          item.edit = false;
        }
      });
    }

    $scope.getLineItemsRemainingCount = function (itemEdit) {
      if (itemEdit && itemEdit.orderRef && itemEdit.orderRef.lineItems) {
        var unremovedCount = 0;
        if (itemEdit.lineItems) {
          for (var i = 0; i < itemEdit.lineItems.length; i++) {
            if (itemEdit.lineItems[i].delete != true) {
              unremovedCount += 1;
            }
          }
        }

        var orderCount = 0;
        if (itemEdit.orderRef != null) {
          orderCount = itemEdit.orderRef.lineItems.length;
        }

        var remaining = orderCount - unremovedCount;
        return remaining;
      } else {
        return 0;
      }
    }

    /****************************/
    /***** Select Assignee ******/
    /****************************/

    $scope.selectPerson = function () {
      $scope.$parent.selectPersonForJob($scope.itemEdit.assignees, function (person) {
        if (person != null) {
          if ($scope.itemEdit.assignees == null) {
            $scope.itemEdit.assignees = [];
          }

          var people = [];
          if ($stateParams.device == 'desktop') {
            people = person;
          } else {
            // expecting a single object in return
            people = [];
            people.push(person);
          }

          if ($scope.itemEdit.id == null) {
            for (var i = 0; i < people.length; i++) {
              var newAssignee = {};
              newAssignee.assignee = people[i].id;
              newAssignee.name = people[i].name.full;
              newAssignee.status = "Assigned";
              $scope.itemEdit.assignees.push(newAssignee);
            }
            $scope.cleanAssignees = $scope.itemEdit.assignees;
          } else {
            jobService.addAssignee($scope.itemEdit, people, function (updatedJob) {
              $scope.itemEdit.assignees = updatedJob.assignees;
              for (var i = 0; i < $scope.itemEdit.assignees.length; i++) {
                $scope.itemEdit.assignees[i].status = $scope.itemEdit.assignees[i].status.charAt(0).toUpperCase() + $scope.itemEdit.assignees[i].status.slice(1);
                if ($scope.itemEdit.assignees[i].assignee == $scope.currentUser.id) {
                  $scope.itemEdit.userIsAssignee = true;
                  $scope.itemEdit.userAssigneeData = $scope.itemEdit.assignees[i];
                  if (!accessControl.userHasPermission('io.docketbook.ojdapi.updateJob')) {
                    $scope.itemEdit.statusDisplay = $scope.itemEdit.userAssigneeData.status.charAt(0).toUpperCase() + $scope.itemEdit.userAssigneeData.status.slice(1);
                  }
                }
              }
              $scope.resolveToRealEntities();
            }, function (err) {
              swal("Oops!", "Adding assignee failed.", 'error');
            });
          }
        }
      });
    }

    // Unassign a person from a job - show 'are you sure' modal first
    $scope.unassignPerson = function (assignee, method) {
      if ($scope.itemEdit.id == null) {
        var index = $scope.itemEdit.assignees.indexOf(assignee);
        if (index != -1) {
          $scope.itemEdit.assignees.splice(index, 1);
        }
      } else {
        swal({
          title: "Unassign. Are you sure?",
          text: assignee.name + " will be unassigned from this job.",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Yes, unassign " + assignee.name,
          closeOnConfirm: false
        }, function () {
          jobService.removeAssignee($scope.itemEdit, assignee, function (updatedJob) {
            var index = $scope.itemEdit.assignees.indexOf(assignee);
            if (index != -1) {
              $scope.itemEdit.assignees.splice(index, 1);
              swal({
                title: "Unassigned!",
                text: assignee.name + " was unassigned from this job.",
                timer: 2000,
                showConfirmationButton: false,
                type: "success"
              });
            } else {
              swal({
                title: "Oops!",
                text: assignee.name + " could not be unassigned from the job.",
                timer: 2000,
                showConfirmationButton: false,
                type: "error"
              });
            }
            $scope.resolveToRealEntities();
          }, function (err) {
            swal({
              title: "Oops!",
              text: assignee.name + " could not be unassigned from the job.",
              timer: 2000,
              showConfirmationButton: false,
              type: "error"
            });
          });
        });
      }
    }

    /**********************************/
    /***** Access Control Editing *****/
    /**********************************/

    $scope.shareJob = function (job) {
      var userAccessLevels = [];
      $scope.newAccessor = { 'accessLevel': 'forwarder' };
      $scope.accessControlEdit = {};
      $scope.accessControlEdit.jobNumber = job.jobNumber;
      var accessControlEdit = [];
      var currentKeys = Object.keys(job.accessControl);

      for (var i = 0; i < currentKeys.length; i++) {
        var newAccessControlItem = {};
        newAccessControlItem.emailAddress = currentKeys[i];
        newAccessControlItem.accessLevel = "";
        if (job.accessControl[currentKeys[i]].indexOf('editor') != -1) {
          newAccessControlItem.accessLevel = "editor";
        } else if (job.accessControl[currentKeys[i]].indexOf('forwarder') != -1) {
          newAccessControlItem.accessLevel = "forwarder";
        } else if (job.accessControl[currentKeys[i]].indexOf('assignee') != -1) {
          newAccessControlItem.accessLevel = "assignee";
        } else if (job.accessControl[currentKeys[i]].indexOf('viewer') != -1) {
          newAccessControlItem.accessLevel = "viewer";
        }
        newAccessControlItem.accessLevelInitial = newAccessControlItem.accessLevel;
        newAccessControlItem.accessLevelsArray = job.accessControl[currentKeys[i]];

        // Check if supplier
        if (job.supplierContact) {
          var addressKeys = Object.keys(job.supplierContact.contactAddresses);
          for (var j = 0; j < addressKeys.length; j++) {
            if (newAccessControlItem.emailAddress == addressKeys[j]) {
              newAccessControlItem.isSupplier = true;
              break;
            }
          }
        }

        // Check if current user and get accessLevels
        if (newAccessControlItem.emailAddress == $scope.currentUser.emailAddress) {
          for (var j = 0; j < newAccessControlItem.accessLevelsArray.length; j++) {
            userAccessLevels.push(newAccessControlItem.accessLevelsArray[j]);
          }
          newAccessControlItem.isUser = true;
        }

        // Check if current org groups email and get access levels
        if ($scope.currentOrgGroup && $scope.currentOrgGroup.emailAddresses) {
          for (var j = 0; j < $scope.currentOrgGroup.emailAddresses.length; j++) {
            if ($scope.currentOrgGroup.emailAddresses[j] == newAccessControlItem.emailAddress) {
              for (var k = 0; k < newAccessControlItem.accessLevelsArray.length; k++) {
                userAccessLevels.push(newAccessControlItem.accessLevelsArray[k]);
              }
              break;
            }
          }
        }
        accessControlEdit.push(newAccessControlItem);
      }

      $scope.accessControlEdit.accessControl = accessControlEdit;

      // get max access level
      var maxLevel = "";
      if (userAccessLevels.indexOf('editor') != -1) {
        maxLevel = 'editor';
      } else if (userAccessLevels.indexOf('forwarder') != -1) {
        maxLevel = "forwarder";
      } else if (userAccessLevels.indexOf('assignee') != -1) {
        maxLevel = 'assignee';
      } else if (userAccessLevels.indexOf('viewer') != -1) {
        maxLevel = 'viewer';
      }

      $scope.accessControlEdit.maxLevel = maxLevel;
      $mdBottomSheet.hide();
      $("#shareJobModal").fadeIn(100);
    }

    var maxLevelAllocations = {
      'viewer': ['viewer'],
      'forwarder': ['viewer'],
      'editor': ['editor', 'viewer', 'assignee', 'forwarder', 'remove'],
      'assignee': ['']
    }

    $scope.canSetAccessLevel = function (accessor, accessLevel) {
      if (!$scope.accessControlEdit || !$scope.accessControlEdit.maxLevel) {
        return false;
      }

      if (maxLevelAllocations[$scope.accessControlEdit.maxLevel].indexOf(accessLevel) != -1) {
        return true;
      } else {
        return false;
      }
    }

    $scope.canChangeAccessLevel = function (accessor) {
      if (!$scope.accessControlEdit || !$scope.accessControlEdit.maxLevel) {
        return false;
      }

      if (maxLevelAllocations[$scope.accessControlEdit.maxLevel].indexOf(accessor.accessLevel) != -1) {
        return true;
      } else {
        return false;
      }
    }

    $scope.addNewAccessor = function () {
      if ($scope.newAccessor.emailAddress != "") {
        $scope.newAccessor.new = true;
        var emailAddresses = $scope.newAccessor.emailAddress.split(',');
        if (emailAddresses.length > 1) {
          for (var i = 0; i < emailAddresses.length; i++) {
            var newAccessor = angular.copy($scope.newAccessor);
            newAccessor.emailAddress = emailAddresses[i];
            $scope.accessControlEdit.accessControl.push(newAccessor);
          }
        } else {
          $scope.accessControlEdit.accessControl.push($scope.newAccessor);
        }
        $scope.newAccessor = { 'accessLevel': 'viewer' };
      }
    }

    $scope.selectAccessorContact = function () {
      $("#shareJobModal").fadeOut(100);
      $scope.$parent.selectContactForJob(function (contactSelected) {
        if (contactSelected != null) {
          $("#shareJobModal").fadeIn(100);
          /*if ( contactSelected.contactAddresses && contactSelected.contactAddresses[0].emailAddress ) {
            $scope.newAccessor.emailAddress = contactSelected.contactAddresses[0].emailAddress;
          }*/
          var emailAddresses = [];
          for (var i = 0; i < contactSelected.contactAddresses.length; i++) {
            if (contactSelected.contactAddresses[i].emailAddress) {
              emailAddresses.push(contactSelected.contactAddresses[i].emailAddress);
            }
          }
          $scope.newAccessor.emailAddress = emailAddresses.join(',');
        } else {
          $("#shareJobModal").fadeIn(100);
        }
      });
    }

    $scope.selectSubcontractorContactForAddition = function () {
      $("#shareJobModal").fadeOut(100);
      $scope.$parent.selectContactForJob(function (contactSelected) {
        if (contactSelected && contactSelected.contactAddresses && contactSelected.contactAddresses[0].emailAddress) {
          $scope.accessControlEdit = {
            accessControl: [{
              emailAddress: contactSelected.contactAddresses[0].emailAddress,
              new: true,
              accessLevel: "forwarder"
            }]
          }
          $scope.saveAccessControlEdit();
        }
      });
    }

    $scope.removeSubcontractor = function (emailAddress) {
      $scope.accessControlEdit = {
        accessControl: [{
          emailAddress: emailAddress,
          remove: true,
          accessLevelInitial: "forwarder",
          accessLevel: "remove",
          accessLevelsArray: ["forwarder"]
        }]
      }
      $scope.saveAccessControlEdit();
    }

    $scope.saveAccessControlEdit = function () {
      $scope.accessControlEdit.loading = true;
      // convert back to accessControl object
      var accessControlObject = {};
      for (var i = 0; i < $scope.accessControlEdit.accessControl.length; i++) {
        var thisAccessItem = $scope.accessControlEdit.accessControl[i];
        if (thisAccessItem.new == true) {
          accessControlObject[thisAccessItem.emailAddress] = { 'add': [thisAccessItem.accessLevel] };
        } else if (thisAccessItem.accessLevelInitial != thisAccessItem.accessLevel) {
          // access has been changed - need to construct add/remove fields
          if (thisAccessItem.accessLevel == 'remove') {
            accessControlObject[thisAccessItem.emailAddress] = { 'remove': thisAccessItem.accessLevelsArray };
          } else {
            accessControlObject[thisAccessItem.emailAddress] = { 'remove': thisAccessItem.accessLevelsArray, 'add': [thisAccessItem.accessLevel] };
          }
        }
      }

      if ($scope.itemEdit.id == null) {
        $scope.itemEdit.accessControl = Object.assign({}, $scope.itemEdit.accessControl, accessControlObject);
        $scope.refreshForwardersFromAccessControl();
      } else {
        jobService.updateAccessControl($scope.itemEdit.id, accessControlObject, function (jobUpdated) {
          $("#shareJobModal").fadeOut(100);
          // get updated job object
          $scope.itemEdit.accessControl = jobUpdated.accessControl;
          $scope.refreshForwardersFromAccessControl();
        }, function (err) {
          $scope.accessControlEdit.loading = false;
          $scope.refreshForwardersFromAccessControl();
          swal({
            title: "Error!",
            text: "An error occured while sharing the job.",
            type: "error",
            confirmButtonText: "Ok, got it."
          });
        });
      }
    }

    $scope.closeAccessControlModal = function () {
      $("#shareJobModal").fadeOut(100);
    }

    /***************************/
    /**** UI Functionality *****/
    /***************************/

    $scope.openMobileTab = function (tabName) {
      $scope.currentTab = tabName;
      var leftOffset = $("#tab" + tabName).offset().left + $("#tab" + tabName).width();
      var width = $(".tabBarMobile.detailTabBar").width();
      var M = width / 2;
      var Y = leftOffset;
      var X = $(".tabBarMobile.detailTabBar").scrollLeft();

      if (Y > M) {
        // scroll right
        $(".tabBarMobile.detailTabBar").animate({ scrollLeft: X + (Y - M) }, 600);
      } else {
        // scroll left
        $(".tabBarMobile.detailTabBar").animate({ scrollLeft: X - (M - Y) }, 600);
      }
    }

    /******************/
    /***** Toasts *****/
    /******************/

    $scope.showToast = function (message) {
      var toast = {};
      if ($stateParams.device == 'desktop') {
        toast = $mdToast.simple()
          .textContent(message)
          .position('top right')
          .hideDelay(3000);
      } else {
        toast = $mdToast.simple()
          .textContent(message)
          .position('top right')
          .hideDelay(3000)
          .capsule(false)
          .parent(document.querySelectorAll('#toasterInner'));
      }
      $mdToast.show(toast).then();
    }

    /***********************/
    /**** Bottom Sheet *****/
    /***********************/

    $scope.openBottomSheet = function () {
      $mdBottomSheet.show({
        templateUrl: 'views/pages/jobs/mobile/jobsBottomSheet.html',
        scope: $scope,
        preserveScope: true
      }).then(function () {

      });
    }

    /*****************************/
    /***** Date/Time Pickers *****/
    /*****************************/

    $scope.showDatePicker = function (field, ev) {
      $mdpDatePicker($scope.itemEdit[field], {
        targetEvent: ev
      }).then(function (selectedDate) {
        $scope.itemEdit[field] = selectedDate;
      });
    }

    $scope.showTimePicker = function (field, ev) {
      $mdpTimePicker($scope.itemEdit[field], {
        targetEvent: ev,
        autoSwitch: true
      }).then(function (selectedTime) {
        $scope.itemEdit[field] = selectedTime;
      });
    }

    /**********************************/
    /***** Alert Parent Controller ****/
    /**********************************/

    $scope.$parent.detailControllerReady();

  });



// WEBPACK FOOTER //
// ./src/controllers/jobs/detailController.js